export enum InterventionApplicationsTypes {
  PESTICIDE = 'pesticide',
  NUTRIENTS = 'nutrients',
  IRRIGATION = 'irrigation',
}
